import { Container, IDestroyOptions } from "@pixi/display";
import { Spine } from "pixi-spine";
import { PlayerModel } from "../../../models/player/PlayerModel";
import { GameUIResourcesPackage } from "../../../../preloader/resources/GameUIResourcesPackage";
import { GameModel } from "../../../models/game/GameModel";
import { AudioManager } from "../../../../../audio/AudioManager";
import { AudioNames } from "../../../../../audio/AudioNames";

export class ComboView extends Container {
    private animation: Spine;
    private currentCoverage: number = 0;
    constructor(
        private readonly resources: GameUIResourcesPackage,
        private readonly audioManager: AudioManager,
        private readonly playerModel: PlayerModel,
        private readonly gameModel: GameModel
    ) {
        super();
        this.playerModel.onChanged.add(this.checkAnimationTrigger, this);
    }

    private checkAnimationTrigger(): void {
        const newCoverage = this.gameModel.countFieldCoverage();

        const oldTensBoundary = Math.floor(this.currentCoverage / 10);

        const newTensBoundary = Math.floor(newCoverage / 10);

        const isTriggered = newTensBoundary > oldTensBoundary;

        this.currentCoverage = newCoverage;

        if (isTriggered && newCoverage < 100) {
            this.playAnimation();
        }
    }

    private async playAnimation(): Promise<void> {
        const animationKey = Math.floor(this.currentCoverage / 10);
        const animationName: string = `grace_${animationKey}`;
        this.audioManager.play(AudioNames.Combo);

        return new Promise((resolve) => {
            this.animation = new Spine((this.resources.assets_game_effects_combo_grace_json as any).spineData);
            this.animation.state.setAnimation(0, animationName, false);
            this.addChild(this.animation);
            this.animation.state.addListener({
                complete: () => {
                    requestAnimationFrame(() => {
                        this.animation.state?.clearListeners();
                        this.removeChild(this.animation).destroy({ children: true });
                        resolve();
                    });
                }
            });
        });
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.playerModel.onChanged.remove(this.playAnimation, this);
        super.destroy(options);
    }

}